"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailTemplateUpdate = exports.emailTemplateSuccess = exports.emailTemplateSoftDeletedList = exports.emailTemplateSoftDeleteRestore = exports.emailTemplateSoftDelete = exports.emailTemplateReset = exports.emailTemplateList = exports.emailTemplateFetch = exports.emailTemplateError = exports.emailTemplateDelete = exports.emailTemplateAdd = void 0;
var _emailTemplate = require("./emailTemplate.constant");
// @flow

// common success
var emailTemplateSuccess = function emailTemplateSuccess(actionType, data) {
  return {
    type: _emailTemplate.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.emailTemplateSuccess = emailTemplateSuccess;
var emailTemplateError = function emailTemplateError(actionType, error) {
  return {
    type: _emailTemplate.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list.
 */
exports.emailTemplateError = emailTemplateError;
var emailTemplateList = function emailTemplateList(data) {
  return {
    type: _emailTemplate.actionTypes.LIST,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.emailTemplateList = emailTemplateList;
var emailTemplateFetch = function emailTemplateFetch(data) {
  return {
    type: _emailTemplate.actionTypes.FETCH,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
exports.emailTemplateFetch = emailTemplateFetch;
var emailTemplateDelete = function emailTemplateDelete(data) {
  return {
    type: _emailTemplate.actionTypes.DELETE,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.emailTemplateDelete = emailTemplateDelete;
var emailTemplateAdd = function emailTemplateAdd(data) {
  return {
    type: _emailTemplate.actionTypes.ADD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.emailTemplateAdd = emailTemplateAdd;
var emailTemplateUpdate = function emailTemplateUpdate(data) {
  return {
    type: _emailTemplate.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Reset data
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.emailTemplateUpdate = emailTemplateUpdate;
var emailTemplateReset = function emailTemplateReset() {
  return {
    type: _emailTemplate.actionTypes.RESET
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used for soft delete .
 */
exports.emailTemplateReset = emailTemplateReset;
var emailTemplateSoftDelete = function emailTemplateSoftDelete(data) {
  return {
    type: _emailTemplate.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used for restore.
 */
exports.emailTemplateSoftDelete = emailTemplateSoftDelete;
var emailTemplateSoftDeleteRestore = function emailTemplateSoftDeleteRestore(data) {
  return {
    type: _emailTemplate.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * soft delete list
 * @param payload
 * @returns api response
 * @description this function used for soft delete list.
 */
exports.emailTemplateSoftDeleteRestore = emailTemplateSoftDeleteRestore;
var emailTemplateSoftDeletedList = function emailTemplateSoftDeletedList(data) {
  return {
    type: _emailTemplate.actionTypes.SOFT_DELETE_LIST,
    payload: data
  };
};
exports.emailTemplateSoftDeletedList = emailTemplateSoftDeletedList;